import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgChevronUpDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgChevronUp = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth={2.4} strokeLinecap="square" />
  </svg>
));
